import { render, staticRenderFns } from "./EmptyDocumentIcon.vue?vue&type=template&id=2342e63f&"
import script from "./EmptyDocumentIcon.vue?vue&type=script&lang=js&"
export * from "./EmptyDocumentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports